import { apmBase } from '@elastic/apm-rum';
import { routeHooks } from './route-hooks';
import { getErrorHandler } from './error-handler';
export var ApmVuePlugin = {
  install: function install(Vue, options) {
    var router = options.router,
        _options$apm = options.apm,
        apm = _options$apm === void 0 ? apmBase : _options$apm,
        config = options.config,
        _options$captureError = options.captureErrors,
        captureErrors = _options$captureError === void 0 ? true : _options$captureError;
    apm.init(config);

    if (router) {
      routeHooks(router, apm);
    }

    if (captureErrors) {
      Vue.config.errorHandler = getErrorHandler(Vue, apm);
    }

    Vue.prototype.$apm = apm;
  }
};